module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/ocala_national_forest-25c8a893f6e91d4d7323d9089d3dcd1d.jpg";